export const QUESTIONS = [
  {
    title: 'Baixe o Termo de Pagamento Trocado',
    text: 'Toque no botão abaixo para baixar no seu celular.',
  },
  {
    title: 'Preencha o termo completo',
    text: 'Informe todos os dados solicitados, de forma clara, correta e legível.',
  },
  {
    title: 'Assine e salve',
    text:
      'Assine o termo e salve no seu celular. Pode ser a foto do documento preenchido e assinado.',
  },
  {
    title: 'Envie o documento',
    text: 'Você pode escolher a melhor opção:',
    items: [
      'Aqui mesmo, nesta tela, toque em “Anexar Termo Assinado” para enviar o documento.',
      'Ou, se preferir, na tela inicial, acesse a opção “Envio de arquivo”',
    ],
  },
  {
    title: 'Fale com a nossa Central de Atendimento',
    text:
      'Chame a gente no WhatsApp (22) 2041-0353 ou clique aqui para darmos continuidade à sua solicitação.',
  },
]
